import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_40 } from '../../Button'
import { ButtonSelect, ButtonTextSelectControl } from '../../Select'

import { QA_NAME_PROFILE_MORE_MENU } from './EntityProfileHeaderMoreButton.constants'

import * as styles from './EntityProfileHeaderMoreButton.module.css'

function EntityProfileHeaderMoreButton({
  buttonProps: {
    Button: ButtonComponent = Button.Outlined,
    height: buttonHeight = BUTTON_HEIGHT_40,
    isGrey: buttonIsGrey = false,
    qaName: buttonQaName = QA_NAME_PROFILE_MORE_MENU,
    ...buttonProps
  } = EMPTY_OBJECT,
  buttonText = 'Profile.MoreBtnKey',
  className = styles.EntityProfileHeaderMoreButton,
  options = EMPTY_LIST,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <ButtonSelect
      {...restProps}
      Control={ButtonTextSelectControl}
      className={className}
      controlProps={{
        buttonProps: {
          ...buttonProps,
          Button: ButtonComponent,
          height: buttonHeight,
          isGrey: buttonIsGrey,
          qaName: buttonQaName,
          text: t(buttonText),
        },
      }}
      filter={null}
      listProps={{
        headerProps: {
          Search: null,
        },
        itemProps: {
          contentProps: {
            infoProps: {
              contentTextProps: {
                textProps: {
                  isSecondary: true,
                },
              },
            },
          },
        },
      }}
      options={options}
    />
  )
}

export default EntityProfileHeaderMoreButton
